<template>
  <div
    class="flex flex-col items-center space-y-6 px-3 pt-12 md:flex-row md:justify-between md:space-x-6 md:space-y-0 md:px-6 md:pb-6"
    v-if="getPartnerInfo"
  >
    <div
      class="flex flex-col items-center space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4"
    >
      <!-- PLACEHOLDER IMAGE -->
      <img
        :src="getPartnerInfo.partner_logo"
        :alt="getPartnerInfo.partner_name"
        class="h-[80px] w-[400px] px-6 sm:h-[60px] sm:w-[300px] sm:p-0"
      />
      <div
        class="flex max-w-[600px] items-center justify-center 2xl:max-w-[700px]"
      >
        <p class="text-sm text-gray-500 dark:text-gray-400">
          {{ getPartnerInfo.partner_description }}
        </p>
      </div>
    </div>

    <div
      class="flex flex-none items-center justify-center space-x-4 md:justify-end"
      v-if="getPartnerInfo"
    >
      <a
        v-for="network in socialLinks"
        :key="network"
        :href="getPartnerInfo.social_networks[network]"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        <img :src="`/img/${network}.png`" :alt="imageAlts(network)" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      type: String,
    },
  },

  computed: {
    ...mapGetters({ getPartnerInfo: "marketplace/getPartnerInfo" }),
    socialLinks() {
      const networks = [
        "instagram",
        "facebook",
        "linkedin",
        "whatsapp",
        "telegram",
        "youtube",
        "twitter",
      ];
      return networks.filter(
        (item) => !!this.getPartnerInfo.social_networks[item]
      );
    },
  },

  methods: {
    imageAlts(network) {
      return (
        network &&
        `${
          network === "youtube"
            ? "YouTube"
            : network === "linkedin"
            ? "LinkedIn"
            : network.charAt(0).toUpperCase() + network.slice(1)
        } de ${this.getPartnerInfo.partner_name}`
      );
    },
  },
};
</script>

<style lang="scss"></style>
